import { REPORT_PROPERTIES } from '../../../../constants/generalConstants';
import { useMappings } from '../../../../stores/mappingStore';
import { MasterDescriptorsMapType, ImportTableDescriptorType, ImportTableReportType } from '../../../../types';
import { MASTER_DESCRIPTOR_OVER_PREFIX } from '../../constants';
import ImportDescriptor from '../importDescriptor';
import ImportDescriptorCell from './components/importDescriptorCell';
import MappingReportValue from '../mappingReportValue';
import MappingsReportCell from './components/mappingsReportCell';
import MappingsSortableItem from '../mappingsSortableItem';
import MappingsTableRow from './components/mappingsTableRow';
import MasterDescriptor from '../masterDescriptor';
import MasterDescriptorCell from './components/masterDescriptorCell';
import './styles.css';

type MappingsTablePropsType = {
    reports: ImportTableReportType[];
    handleMasterDescriptorOnDropSwap: () => void;
    handleMasterDescriptorOnDropInsert: () => void;
    handleImportDescriptorOnDropSwap: () => void;
    importDescriptors: ImportTableDescriptorType[];
    masterDescriptorsMap: MasterDescriptorsMapType;
};

function MappingsTable({
    reports,
    handleMasterDescriptorOnDropSwap,
    handleMasterDescriptorOnDropInsert,
    handleImportDescriptorOnDropSwap,
    importDescriptors,
    masterDescriptorsMap,
}: MappingsTablePropsType) {
    const mappings = useMappings();
    return (
        <table className="extraction-table mappings">
            <thead>
                <tr>
                    <th rowSpan={6}>Model Descriptors</th>
                    <th rowSpan={6}>Image imported descriptors</th>
                </tr>
                {REPORT_PROPERTIES.map((prop) => {
                    return (
                        <tr key={prop}>
                            {reports.map((r, i) => {
                                return <th key={i}>{r[prop]}</th>;
                            })}
                        </tr>
                    );
                })}
            </thead>
            <tbody>
                {mappings.map((mapping) => {
                    const rowId = mapping.rowId;
                    const descriptorId = mapping.descriptorId;
                    const masterDescriptor = masterDescriptorsMap[descriptorId];
                    const importDescriptor = importDescriptors.find((d) => d.id === rowId);
                    return (
                        <MappingsTableRow
                            key={descriptorId}
                            rowId={rowId}
                            masterDescriptorId={masterDescriptor?.id ?? null}
                        >
                            <MasterDescriptorCell masterDescriptor={masterDescriptor}>
                                <MappingsSortableItem
                                    strategies={['INSERT', 'SWAP']}
                                    draggingDisabled={!!masterDescriptor}
                                    handleOnDropSwap={handleMasterDescriptorOnDropSwap}
                                    handleOnDropInsert={handleMasterDescriptorOnDropInsert}
                                    id={descriptorId}
                                    overId={`${MASTER_DESCRIPTOR_OVER_PREFIX}${descriptorId}`}
                                >
                                    {!!masterDescriptor && <MasterDescriptor masterDescriptor={masterDescriptor} />}
                                </MappingsSortableItem>
                            </MasterDescriptorCell>
                            <ImportDescriptorCell confidence={mapping.confidence} rowId={rowId}>
                                <MappingsSortableItem
                                    strategies={['SWAP']}
                                    handleOnDropSwap={handleImportDescriptorOnDropSwap}
                                    id={rowId}
                                    overId={descriptorId}
                                >
                                    {!!importDescriptor && (
                                        <ImportDescriptor mapping={mapping} importDescriptor={importDescriptor} />
                                    )}
                                </MappingsSortableItem>
                            </ImportDescriptorCell>
                            {reports.map((r, i) => {
                                const fieldValue = r.rowIdToValue[rowId];
                                return (
                                    <MappingsReportCell key={i}>
                                        {!!fieldValue && <MappingReportValue fieldValue={fieldValue} />}
                                    </MappingsReportCell>
                                );
                            })}
                        </MappingsTableRow>
                    );
                })}
            </tbody>
        </table>
    );
}

export default MappingsTable;
